<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="refresh-alert-status">
    <div class="alert-page-label">
        <strong>{{configData && configData.alertLabel.alertLabel}}</strong>
    </div>
    <button id="defaultSearchButton" tabindex="{{tabLevel}}" type="button" (click)="refreshAlertsInfo()">
              <i class='fa fa-refresh'></i></button>
    <div class="last-refresh">
        <p>{{configData && configData.alertLabel.alertLastRefresh}}</p>
        <span><strong>{{refreshTime ? refreshTime : 'N/A'}}</strong></span>
    </div>

    <div [ngClass]="{selected: selectedTab?.selected}" id='topTab{{selectedTab?.id}}'>
        <span tabindex="{{tabLevel + 1}}" class="tab-text" title="{{selectedTab?.description}}">{{selectedTab?.type}} - {{selectedTab?.subType}}
    </span>
        <i class="fa fa-times" title="Close Tab" tabindex="{{tabLevel + 2}}" (click)='gotoPreviousScreen();' (keyup.space)='gotoPreviousScreen();' (keyup.spacebar)='gotoPreviousScreen();' aria-hidden="true"></i>
    </div>

</div>